import { OnboardingSteps, StepCondition } from '../types';

const evaluateConditions = (
  conditions: StepCondition[],
  steps: OnboardingSteps,
  formOptions: Record<string, unknown>
) => {
  for (const condition of conditions) {
    if (condition.hasOneFieldOption) {
      const options = formOptions[condition.hasOneFieldOption];
      return Array.isArray(options) && options.length === 1;
    }

    // If we are just checking for the existence of options
    if (condition.hasFieldOptions) {
      const options = formOptions[condition.hasFieldOptions];
      return !(!options || (Array.isArray(options) && options.length === 0));
    }

    const { step, field, value, skipped, submitted } = condition;
    const onboardingSteps = steps[step];

    if (!onboardingSteps) {
      // this should not happen, but just in case
      return false;
    }

    if (skipped) {
      const skippedStep = onboardingSteps.find((step) => step.skipped);
      if (!skippedStep) {
        return false;
      }
    }

    // we should guarantee that node there will be only one step submitted,
    // otherwise this is much more complicated and will probably break
    const submittedStep = onboardingSteps.find((step) => step.submitted);
    if (submitted) {
      if (!submittedStep) {
        return false;
      }
    }

    if (field) {
      if (!submittedStep) {
        return false;
      }

      const submittedValue = submittedStep.payload?.[field];
      if (submittedValue !== value) {
        // if the submitted value does not match the condition, we break
        return false;
      }
    }

    // note: if no steps match the conditions, it means our flow is broken
    // and we should probably add a default step to handle this case
  }
  return true;
};

export default evaluateConditions;
